export type PurchaseNotice = {
  name: string
  place: string
}

export const purchaseNotices: PurchaseNotice[] = [
  { name: 'Andrés M.', place: 'Bogotá, Colombia' },
  { name: 'Luis Fernando P.', place: 'Città del Messico, Messico' },
  { name: 'Ricardo S.', place: 'Buenos Aires, Argentina' },
  { name: 'Javier T.', place: 'Lima, Perù' },
  { name: 'Manuel A.', place: 'Madrid, Spagna' },
  { name: 'Diego H.', place: 'Santiago, Cile' },
  { name: 'Wilmer C.', place: 'Caracas, Venezuela' },
  { name: 'Óscar V.', place: 'Guayaquil, Ecuador' },
  { name: 'Julio R.', place: 'Montevideo, Uruguay' },
  { name: 'Néstor B.', place: 'Panama City, Panama' },
  { name: 'Rafael G.', place: 'San José, Costa Rica' },
  { name: 'Alberto D.', place: 'Valencia, Spagna' },
]
